import { useTheme } from 'styled-components';

/* Utils */
import { i18n } from 'utils/i18n';

/* Styled Components */
import {
  Wrapper,
  Link as StyledLink,
  Heading,
  Container,
  HeadingContainer,
  ColumnContainer,
  RowContainer,
  LinksContainer,
} from 'styles/landing/Footer';

/* Child Components */
import Button, {
  BUTTON_SIZE_KEYS,
  BUTTON_COLOR_KEYS,
} from 'components/common/Button';
import WishLocalLogo from 'components/common/WishLocalLogo';

/* Icons */
import FacebookIcon from 'icons/FacebookIcon';
import InstagramIcon from 'icons/InstagramIcon';
import TwitterIcon from 'icons/TwitterIcon';
import YoutubeIcon from 'icons/YoutubeIcon';

/* Routes */
import { SIGNUP_PAGE_ROUTE } from 'constants/RouteConstants';

/* Contants */
import {
  FACEBOOK_LINK,
  INSTAGRAM_LINK,
  TWITTER_LINK,
  YOUTUBE_LINK,
  BLOG_LINK,
  COMPANY_INFO_LINK,
  CAREERS_LINK,
  SELL_ON_WISH_LINK,
  INTERLECTUAL_PROPERTY_LINK,
} from 'constants/LandingPageConstants';

type PropsType = {
  onClickSignUp?: () => void;
};

const BlueFooterNew = ({ onClickSignUp }: PropsType) => {
  const theme = useTheme();
  const iconStyle = { height: 20, width: 20, color: theme.white };

  return (
    <Wrapper>
      <Container>
        <HeadingContainer>
          <Heading>{i18n('Start growing your business!')}</Heading>
          <Button
            bold
            stretch
            color={BUTTON_COLOR_KEYS.BLUE1}
            size={BUTTON_SIZE_KEYS.LARGE}
            to={SIGNUP_PAGE_ROUTE}
            onClick={onClickSignUp}
          >
            {i18n('Sign up for free')}
          </Button>
        </HeadingContainer>
        <LinksContainer>
          <RowContainer margin="32px 0">
            <ColumnContainer>
              <StyledLink
                href={COMPANY_INFO_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n('Company')}
              </StyledLink>
              <StyledLink
                href={BLOG_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n('Blog')}
              </StyledLink>
              <StyledLink
                href={CAREERS_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n('Careers')}
              </StyledLink>
            </ColumnContainer>
            <ColumnContainer margin="0 0 0 8%">
              <StyledLink
                href={SELL_ON_WISH_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n('Sell on Wish')}
              </StyledLink>
              <StyledLink
                href={INTERLECTUAL_PROPERTY_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n('Intellectual Property')}
              </StyledLink>
            </ColumnContainer>
          </RowContainer>
          <ColumnContainer style={{ marginRight: 40 }}>
            <WishLocalLogo color={theme.white} width="168px" />
            <RowContainer
              margin="16px 0"
              style={{ justifyContent: 'space-between', width: 120 }}
            >
              <a href={FACEBOOK_LINK} target="_blank" rel="noopener noreferrer">
                <FacebookIcon overrideStyle={iconStyle} />
              </a>
              <a
                href={INSTAGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon overrideStyle={iconStyle} />
              </a>
              <a href={TWITTER_LINK} target="_blank" rel="noopener noreferrer">
                <TwitterIcon overrideStyle={iconStyle} />
              </a>
              <a href={YOUTUBE_LINK} target="_blank" rel="noopener noreferrer">
                <YoutubeIcon overrideStyle={iconStyle} />
              </a>
            </RowContainer>
            <StyledLink noHover>
              © {new Date().getFullYear()} ContextLogic Inc.
            </StyledLink>
          </ColumnContainer>
        </LinksContainer>
      </Container>
    </Wrapper>
  );
};

export default BlueFooterNew;
